<template>
    <slot name="form-customer-password" v-bind="this"></slot>
</template>

<script>

import FormValidator from "lib/form-validator.mjs";


export default {
    props: {
        customer: { type: String, required: true },
        csrfToken: { type: String, required: true },
        editPasswordUrl: { type: String, required: false },
        redirectPasswordIndex: { type: String, required: false }
    },
    data() {
        return {
            formValidator: new FormValidator({
                password: {
                    required: true,
                    type: 'string',
                    min: 6,
                    max: 30
                },
                new_password: {
                    required: true,
                    type: 'strong_password',
                    min: 10,
                    max: 30
                }

            }, {
                password: '',
                new_password: '',
            }),

            errors: {
                password: { init: 1 },
                new_password: { init: 1 },
            },

            password: '',
            new_password: '',
            confirm_password: '',
            showAlert: false,
            submitLock: true,

        }
    },
    watch: {
        password(val) {
            this.hideError('password');
            this.formValidator.setValue('password', val).then(
                () => {
                    this.evaluateButtonStatus();
                },
                (error) => {
                    this.showError('password', error);
                    this.evaluateButtonStatus();
                }
            );
        },
        new_password(val) {
            this.hideError('new_password');
            this.formValidator.setValue('new_password', val).then(
                () => {
                    this.evaluateButtonStatus();
                },
                (error) => {
                    this.showError('new_password', error);
                    this.evaluateButtonStatus();
                }
            );

            if (this.confirm_password && val !== this.confirm_password) {
                this.errors.confirm_password = { mismatch: true };
            } else {
                this.errors.confirm_password = {};
            }
        },

        confirm_password(val) {
            if (val !== this.new_password) {
                this.errors.confirm_password = { mismatch: true };
            } else {
                this.errors.confirm_password = {};
            }
        }
    },
    methods: {
        hideError(name) {
            this.errors[name] = {}
        },
        showError(name, error) {
            this.errors[name] = {};
            this.errors[name][error] = true;
        },
        evaluateButtonStatus() {
            for (let error in this.errors) {
                if (Object.keys(this.errors[error]).length > 0) {
                    this.submitLock = true;
                    return;
                }
            }
            this.submitLock = false;
        },

        handleEditPassword(e) {
            e.preventDefault();
            this.$emit('wait', true)

            const formData = new FormData();
            formData.append('password', this.password)
            formData.append('new_password', this.new_password)
            formData.append('confirm_password', this.confirm_password)
            formData.append('_token', this.csrfToken)

            fetch(this.editPasswordUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'Accept': 'application/json',
                }
            })
                .then(response => {
                    return response.json().then(data => {
                        if (!response.ok) throw data;
                        return data;
                    });
                })
                .then(data => {
                    this.showAlert = true;
                })
                .catch(error => {
                    if (error.message === 'Current password does not match') {
                        this.errors.password = { mismatch: true }
                    }
                    else if (error.errors && error.errors.confirm_password) {
                        this.errors.confirm_password = { mismatch: true }
                        this.errorMessageConfirm = error.errors.confirm_password[0]
                    }
                    this.$emit('wait', false)
                })

        },
    }
}
</script>
